var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import { useConfig } from '../context/ConfigContext';
import { useEventApi } from './useEvent/useEventApi';
import { useEventComposerGlobalContext } from '../composers/EventComposerGlobalContext';
import { transformSpaceAPIToSpaceType } from '../SpaceBooking/utils';
/**
 * Fetches full space details for a space returned by the invitee search and
 * appends it to `form.spaces`. Uses the shared `fetchSpace` from `useEventApi`
 * so error handling is forwarded through the composer's `onError` channel.
 */
export var useAddSpaceFromSearch = function () {
    var _a = useConfig(), environmentUrls = _a.environmentUrls, userContext = _a.userContext, tenantId = _a.tenantId, accessToken = _a.accessToken;
    var onError = useEventComposerGlobalContext().onError;
    var fetchSpace = useEventApi({
        onError: onError,
        apiUrl: environmentUrls.apiUrl,
        baseApiUrl: environmentUrls.baseApiUrl,
        currentOrg: userContext.currentOrg,
        tenantId: tenantId,
        accessToken: accessToken,
    }).fetchSpace;
    var _b = useFormContext(), setValue = _b.setValue, getValues = _b.getValues;
    var addSpaceById = useCallback(function (spaceId) { return __awaiter(void 0, void 0, void 0, function () {
        var currentSpaces, spaceApi, space, freshSpaces, updatedSpaces;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    currentSpaces = (_a = getValues('spaces')) !== null && _a !== void 0 ? _a : [];
                    if (currentSpaces.some(function (s) { return s.id === spaceId; }))
                        return [2 /*return*/];
                    return [4 /*yield*/, fetchSpace({ spaceId: String(spaceId) })];
                case 1:
                    spaceApi = _c.sent();
                    if (!spaceApi)
                        return [2 /*return*/];
                    space = transformSpaceAPIToSpaceType(spaceApi);
                    freshSpaces = (_b = getValues('spaces')) !== null && _b !== void 0 ? _b : [];
                    if (freshSpaces.some(function (s) { return s.id === spaceId; }))
                        return [2 /*return*/];
                    updatedSpaces = space.isManaged ? [space] : __spreadArray(__spreadArray([], __read(freshSpaces), false), [space], false);
                    setValue('spaces', updatedSpaces, { shouldDirty: true });
                    return [2 /*return*/];
            }
        });
    }); }, [fetchSpace, getValues, setValue]);
    return { addSpaceById: addSpaceById };
};
